import { Compass } from '@/components/icons';
import { EmptyState, LinkButton } from '@/components/ui';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<Compass className="size-6" />}
      title="Page not found"
      description="The page you are looking for does not exist or was moved."
      action={<LinkButton to="/">Back to start</LinkButton>}
    />
  );
}
